export function ContactPersonValidator() {
    var errors = false;

    var ids = ['ansprechpartner', 'telefon_2','email_2', 'first_aid', 'swimming_permission'];

    for (var idx = 0; idx < ids.length; idx++) {
        var currentElement = ids[idx];
        if (document.getElementById( currentElement ).value == '') {
            document.getElementById( currentElement ).classList.remove('input_element_valid');
            document.getElementById( currentElement ).classList.add('input_element_error');
            errors = true;
        } else {
            document.getElementById( currentElement ).classList.add('input_element_valid');
            document.getElementById( currentElement ).classList.remove('input_element_error');
        }
    }


    if (parseInt(document.getElementById('swimming_permission').value) === -1) {
        document.getElementById( 'swimming_permission' ).classList.remove('input_element_valid');
        document.getElementById( 'swimming_permission' ).classList.add('input_element_error');
        errors = true
    } else {
        document.getElementById( 'swimming_permission' ).classList.add('input_element_valid');
        document.getElementById( 'swimming_permission' ).classList.remove('input_element_error');
    }

    if (parseInt(document.getElementById('first_aid').value) < 0) {
        document.getElementById( 'first_aid' ).classList.remove('input_element_valid');
        document.getElementById( 'first_aid' ).classList.add('input_element_error');
        errors = true
    } else {
        document.getElementById( 'first_aid' ).classList.add('input_element_valid');
        document.getElementById( 'first_aid' ).classList.remove('input_element_error');
    }

    return !errors;
}

export function SelectedAddons() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"][name^="addons["]');
    const selectedIds = [];

    checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
            const match = checkbox.name.match(/^addons\[(\d+)]$/);
            if (match) {
                selectedIds.push(parseInt(match[1], 10));
            }
        }
    });

    return selectedIds;
}

export function ContactDataValidator()  {
    var errors = false;

    var ids = ['vorname', 'nachname','geburtsdatum', 'email_1', 'strasse', 'hausnummer', 'plz', 'ort'];

    for (var idx = 0; idx < ids.length; idx++) {
        var currentElement = ids[idx];
        if (document.getElementById( currentElement ).value == '') {
            document.getElementById( currentElement ).classList.remove('input_element_valid');
            document.getElementById( currentElement ).classList.add('input_element_error');
            errors = true;
        } else {
            document.getElementById( currentElement ).classList.add('input_element_valid');
            document.getElementById( currentElement ).classList.remove('input_element_error');
        }
    }


    if (parseInt(document.getElementById('localgroup').value) < 0) {
        document.getElementById( 'localgroup' ).classList.remove('input_element_valid');
        document.getElementById( 'localgroup' ).classList.add('input_element_error');
        errors = true
    } else {
        document.getElementById( 'localgroup' ).classList.add('input_element_valid');
        document.getElementById( 'localgroup' ).classList.remove('input_element_error');
    }

    return !errors;
}

export function ArrivalDepratureValidator(event_start, event_end)  {
    var errors = false;

    var ids = ['anreise', 'abreise'];

    for (var idx = 0; idx < ids.length; idx++) {
        var currentElement = ids[idx];

        if (document.getElementById( currentElement ).value == '') {
            document.getElementById( currentElement ).classList.remove('input_element_valid');
            document.getElementById( currentElement ).classList.add('input_element_error');
            errors = true;
        } else {
            document.getElementById( currentElement ).classList.add('input_element_valid');
            document.getElementById( currentElement ).classList.remove('input_element_error');
        }
    }

    if (errors) {
        return false;
    }

    var anreise = new Date( document.getElementById( 'anreise' ).value );
    var abreise = new Date( document.getElementById( 'abreise' ).value );

    if (abreise < anreise) {
        document.getElementById('anreise' ).classList.remove('input_element_valid');
        document.getElementById( 'anreise' ).classList.add('input_element_error');
        document.getElementById( 'abreise' ).classList.remove('input_element_valid');
        document.getElementById( 'abreise' ).classList.add('input_element_error');

        return false;
    }

    if (anreise < event_start) {
        document.getElementById('anreise' ).classList.remove('input_element_valid');
        document.getElementById( 'anreise' ).classList.add('input_element_error');
        errors = true;
    } else {
        document.getElementById( 'anreise' ).classList.add('input_element_valid');
        document.getElementById( 'anreise' ).classList.remove('input_element_error');
    }

    if (abreise > event_end) {
        document.getElementById( 'abreise' ).classList.remove('input_element_valid');
        document.getElementById( 'abreise' ).classList.add('input_element_error');
        errors = true;
    } else {
        document.getElementById( 'abreise' ).classList.add('input_element_valid');
        document.getElementById( 'abreise' ).classList.remove('input_element_error');
    }

    return !errors;

    if ( ! errors) {
        days = (abreise - anreise) / 86400 / 1000;
        days = days + 1;
        if ('1' !== solea_event.solidarity_event) {
            document.getElementById( 'total_amount' ).innerHTML = solea_format_amount( document.getElementById( 'solea_amount' ).value * days );
        }
        showStep( 6 );
    }

    var errors = false;
}

export function FinalValidator() {
    var no_errors = true;

    if (document.getElementById('summary_information_correct').checked === false) {
        document.getElementById('summary_information_correct_label').classList.add('dsgvo_error');
        no_errors = false;
    } else {
        document.getElementById('summary_information_correct_label').classList.remove('dsgvo_error');
    }

    if (document.getElementById('summary_accept_terms').checked === false) {
        document.getElementById('summary_accept_terms_label').classList.add('dsgvo_error');
         no_errors = false;
    } else {
        document.getElementById('summary_accept_terms_label').classList.remove('dsgvo_error');
    }

    if (document.getElementById('legal_accepted').checked === false) {
        document.getElementById('legal_accepted_label').classList.add('dsgvo_error');
        no_errors = false;
    } else {
        document.getElementById('legal_accepted_label').classList.remove('dsgvo_error');
    }

    if (document.getElementById('payment').checked === false) {
        document.getElementById('payment_label').classList.add('dsgvo_error');
        no_errors = false;
    } else {
        document.getElementById('payment_label').classList.remove('dsgvo_error');
    }

    return no_errors;
}